import { Link, useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';
import { useAuth } from '../App';
import { LogOut, User, LayoutDashboard, Stethoscope, ClipboardList, Package } from 'lucide-react';

export default function Navbar() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut(auth);
    navigate('/');
  };

  return (
    <nav className="bg-white/80 backdrop-blur-md sticky top-0 z-50 border-b border-text-muted/10 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20">
          <div className="flex items-center">
            <Link to="/" className="flex-shrink-0 flex items-center">
              <img src="/logo.png" alt="Novità Telemedicina" className="h-12 w-auto" />
            </Link>
            <div className="hidden lg:ml-12 lg:flex lg:space-x-10">
              <Link to="/" className="text-sm font-bold text-text-main hover:text-primary transition-colors uppercase tracking-wider">Início</Link>
              <a href="#planos" className="text-sm font-bold text-text-main hover:text-primary transition-colors uppercase tracking-wider">Planos</a>
              <a href="mailto:contato@novitahomecare.com.br" className="text-sm font-bold text-text-main hover:text-primary transition-colors uppercase tracking-wider">Contato</a>
              {user && (
                <div className="flex items-center space-x-10 pl-10 border-l border-text-muted/10">
                  <Link to="/dashboard" className="inline-flex items-center text-sm font-bold text-text-main hover:text-primary transition-colors uppercase tracking-wider">
                    <LayoutDashboard className="w-4 h-4 mr-2" /> Dashboard
                  </Link>
                  {(user.role === 'attendant' || user.role === 'admin') && (
                    <>
                      <Link to="/triage" className="inline-flex items-center text-sm font-bold text-text-main hover:text-primary transition-colors uppercase tracking-wider">
                        <ClipboardList className="w-4 h-4 mr-2" /> Triagem
                      </Link>
                      <Link to="/inventory" className="inline-flex items-center text-sm font-bold text-text-main hover:text-primary transition-colors uppercase tracking-wider">
                        <Package className="w-4 h-4 mr-2" /> Estoque
                      </Link>
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="flex items-center space-x-6">
            {user ? (
              <div className="flex items-center space-x-6">
                <Link to="/profile" className="flex items-center space-x-3 px-4 py-2 bg-bg-light rounded-xl border border-text-muted/10 hover:bg-text-muted/10 transition-all">
                  <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center text-white font-black text-xs shadow-sm">
                    {user.name.charAt(0).toUpperCase()}
                  </div>
                  <span className="text-sm font-bold text-text-main hidden sm:block">{user.name.split(' ')[0]}</span>
                </Link>
                <button
                  onClick={handleLogout}
                  className="p-2 text-text-muted hover:text-red-500 transition-colors"
                  title="Sair"
                >
                  <LogOut className="w-5 h-5" />
                </button>
              </div>
            ) : (
              <div className="flex items-center space-x-6">
                <Link to="/login" className="text-sm font-bold text-text-main hover:text-primary transition-colors px-4 py-2 uppercase tracking-wider">
                  Entrar
                </Link>
                <Link
                  to="/signup"
                  className="inline-flex items-center px-6 py-3 bg-primary text-white text-sm font-black rounded-xl shadow-lg shadow-primary/20 hover:bg-primary-dark transition-all uppercase tracking-wider"
                >
                  Cadastrar
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}
